/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import WCCartParticipantsForm from "./modules/WCCartParticipantsForm";
import WCCartCrossSellSlider from "./modules/WCCartCrossSellSlider";
import WCCartTaxSwitch from "./modules/WCCartTaxSwitch";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const myWCCartParticipantsForm = new WCCartParticipantsForm();
    const myWCCartCrossSellSlider = new WCCartCrossSellSlider();
    const myWCCartTaxSwitch = new WCCartTaxSwitch();
});
